import service from '@api/config'

// 获取列表数据
export const projectList = (data) => {
  return service.request({
    url: `/index/search/contents`,
    method: 'post',
    data: data
  })
}

// 工种查询
export const getWorkList = (data) => {
  return service.request({
    url: `/typeOfWork/selectList`,
    method: 'post',
    data: data
  })
}

// 所有省以及热门城市查询
export const selectProvinceList = (data) => {
  return service.request({
    url: `/city/selectProvinceList`,
    method: 'post',
    data: data
  })
}

// 根据省查询所有市
export const selectCitiesByProvinceId = (data) => {
  return service.request({
    url: `/city/selectCitiesByProvinceId`,
    method: 'post',
    data: data
  })
}

// 获取发布时间用于筛选
export const getPubDay = (data) => {
  return service.request({
    url: `/search/pubDay`,
    method: 'post',
    data: data
  })
}

// 根据名称搜索省市
export const selectPCByName = (data) => {
  return service.request({
    url: `/city/selectPCByName`,
    method: 'post',
    data: data
  })
}

// 获取热门工种
export const typeOfWork = (data) => {
  return service.request({
    url: `/search/typeOfWork`,
    method: 'post',
    data: data
  })
}

// 获取快捷搜索内容
export const selectQuickFilter = (data) => {
  return service.request({
    url: `/find/work/selectQuickFilter`,
    method: 'post',
    data: data
  })
}

// 查询工种分类
export const selectCategoryList = (data) => {
  return service.request({
    url: `/typeOfWork/selectCategoryList`,
    method: 'post',
    data: data
  })
}

// 根据条件查询工种
export const selectByCondition = (data) => {
  return service.request({
    url: `/typeOfWork/selectByCondition`,
    method: 'post',
    data: data
  })
}

// 根据名称查询城市
export const selectCityList = (data) => {
  return service.request({
    url: `/city/selectByName`,
    method: 'post',
    data: data
  })
}
